
export const mockComplianceAiResponse = {
  summary: {
    complianceLevel: "medium",
    riskExposure: "moderate",
    recommendations: [
      "Implement a more robust documentation system for ESG data collection",
      "Formalize data validation processes with third-party verification",
      "Enhance board oversight of sustainability reporting"
    ],
    timeline: "3-6 months",
    estimatedCost: "€15,000 - €25,000"
  },
  regulatoryAnalysis: [
    {
      framework: "CSRD",
      applicability: "High",
      complianceStatus: "Partial",
      keyGaps: [
        "Missing comprehensive materiality assessment",
        "Limited scope of emissions calculations",
        "Inadequate verification protocol"
      ],
      recommendations: [
        "Conduct full double materiality assessment by Q3",
        "Expand emissions tracking to include all Scope 3 categories by Q4",
        "Implement third-party verification process for all reported data"
      ]
    },
    {
      framework: "EU Taxonomy",
      applicability: "Medium",
      complianceStatus: "Minimal",
      keyGaps: [
        "Limited screening of economic activities against technical criteria",
        "Insufficient documentation of alignment assessment"
      ],
      recommendations: [
        "Screen all revenue streams against technical screening criteria",
        "Document assessment methodology for capital expenditures"
      ]
    }
  ]
};
